import React, { useState, useEffect } from "react";
import { Col, Row, Form, Button, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
// component
import BusinessLogo from "./component/business_logo";
import BusinessName from "./component/business_name";
import BusinessIRD from "./component/business_ird";
import BusinessFirstName from "./component/business_first_name";
import BusinessLastName from "./component/business_last_name";
import BusinessPhone from "./component/business_phone";
import BusinessEmail from "./component/business_email";
import BusinessAdress from "./component/business_address";
import BusinessAdressSuburb from "./component/business_address_suburb";
import BusinessAdressCity from "./component/business_address_city";
import BusinessAdressState from "./component/business_address_state";
import BusinessAdressPostCode from "./component/business_address_post_code";
// redux
import { updateOwnerInfo } from "../../store/role/role.action";
import { updateUserInfo } from "../../store/user/user.action";
import { ownerSelector } from "../../store/role/role.selector";
import { getUrlfromPath } from "../../store/media/media.action";

const wrapperCol = {
  xs: {
    span: 24,
    offset: 0,
  },
  sm: {
    span: 18,
    offset: 0,
  },
};

const labelCol = {
  xs: {
    span: 24,
    offset: 0,
  },
  sm: {
    span: 6,
    offset: 0,
  },
};

const resetData = (owner, form) => {
  const values = {
    logo: owner?.logo || "",
    bussinessName: owner?.bussinessName || "",
    firstName: owner?.firstName || "",
    lastName: owner?.lastName || "",
    ird: owner?.ird || "",
    phone: owner?.phone || "",
    email: owner?.email || "",
    address: owner?.address || "",
    postCode: owner?.postCode || "",
    state: owner?.state || "",
    subUrb: owner?.subUrb || "",
    city: owner?.city || "",
  };
  form.setFieldsValue(values);
};

const Business = () => {
  // -------------------------- VAR --------------------------
  const [form] = Form.useForm();
  const { t } = useTranslation("translation", { keyPrefix: "business" });
  // -------------------------- STATE --------------------------
  const [logo, setLogo] = useState("");
  const [loading, setLoading] = useState(false);
  const [edit, setEdit] = useState(false);

  // -------------------------- REDUX --------------------------

  const dispatch = useDispatch();
  const owner = useSelector(ownerSelector);

  // -------------------------- FUNCTION --------------------------

  const onSelectLogo = (uri) => {
    setLogo(uri);
    form.setFieldsValue({ logo: uri });
  };

  const onSelectAddress = (values) => {
    form.setFieldsValue(values);
  };

  const handleEdit = () => {
    resetData(owner, form);
    setEdit(true);
  };

  const handleCancel = () => {
    resetData(owner, form);
    setEdit(false);
  };

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (owner) {
      resetData(owner, form);
      setLogo(owner?.logo || "");
    }
  }, [owner, form]);

  // -------------------------- DATA FUNCTION --------------------------

  const onFinish = (values) => {
    setLoading(true);
    const update = {
      ...values,
      logo: logo,
    };

    const updateUser = {
      email: values?.email || "",
      password: values?.password || "",
      firstName: values?.firstName || "",
      lastName: values?.lastName || "",
      phone: values?.phone || "",
    };

    dispatch(
      updateOwnerInfo({ update }, (response) => {
        setLoading(false);
        if (response?.status === 200) {
          message.success("Update Business Successfully!");
          dispatch(updateUserInfo({ update: updateUser }));
          setEdit(false);
        }
        if (response?.status === 500) {
          message.error(response?.data || "Failed");
        }
      })
    );
  };

  const onFinishFailed = (error) => {
    console.log({ error });
  };

  const handleLog = () => {
    dispatch(getUrlfromPath());
  };

  // -------------------------- RENDER --------------------------

  const renderForm = () => {
    const disabled = loading || !edit;
    return (
      <Form
        name="edit_form"
        autoComplete="off"
        form={form}
        labelCol={labelCol}
        wrapperCol={wrapperCol}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={[16, 0]}>
          <Col xl={24} lg={24} md={24} xs={24}>
            <BusinessLogo
              disabled={disabled}
              logo={logo}
              onSelect={onSelectLogo}
            />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <BusinessName disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <BusinessIRD disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <BusinessFirstName disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <BusinessLastName disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <BusinessPhone disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <BusinessEmail disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={24}>
            <BusinessAdress disabled={disabled} onSelect={onSelectAddress} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <BusinessAdressSuburb disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <BusinessAdressCity disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <BusinessAdressState disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <BusinessAdressPostCode disabled={disabled} />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            {renderEditButton()}
            {renderSaveButton()}
          </Col>
        </Row>
      </Form>
    );
  };

  const renderEditButton = () => {
    if (!edit) {
      return (
        <Row gutter={[16, 5]} justify="end" align="center">
          <Col>
            <Button
              type="primary"
              className="login-form-button form-button"
              loading={loading}
              onClick={() => handleEdit()}
            >
              {t("edit")}
            </Button>
          </Col>
        </Row>
      );
    }
    return null;
  };

  const renderSaveButton = () => {
    if (edit) {
      return (
        <Row gutter={[16, 5]} justify="end" align="center">
          <Col>
            <Button
              className="login-form-button form-button"
              disabled={loading}
              onClick={() => handleCancel()}
            >
              {t("cancel")}
            </Button>
          </Col>
          <Col>
            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button form-button save"
                loading={loading}
              >
                {t("save")}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      );
    }
    return null;
  };

  const renderLogButton = () => {
    return <Button onClick={handleLog}>Log</Button>;
  };

  // -------------------------- MAIN --------------------------

  return (
    <Row gutter={[16, 5]}>
      <Col xl={24} lg={24} md={24} xs={24}>
        {renderForm()}
        {/* {renderLogButton()} */}
      </Col>
    </Row>
  );
};

export default Business;
